import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ADMIN } from '../../constants/matcher';
import {useFetchApi} from "../../customHooks/useFetch";

const ChatHome = ({ username, setUsername, room, setRoom, socket }) => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user-data"));
  
  const [userType, setUserType] = useState('');
  const [admin, setAdmin] = useState(false);
  const [mentor, setMentor] = useState('');
  const [servant, setServant] = useState('');

  const [mentors, setMentors] = useState([]);
  const [servants, setServants] = useState([]);

  // States for checking the errors
  // const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const [reqData, setreqData] = useState({});
  const { resData } = useFetchApi(reqData);

  // const [reqDataMentors, setreqDataMentors] = useState({});
  // const { resDataMentors } = useFetchApi(reqDataMentors);

  // const [reqDataServants, setreqDataServants] = useState({});
  // const { resDataServants } = useFetchApi(reqDataServants);

  useEffect(() => {
    if (room !== '' && username !== '') {      
      // const __createdtime__ = Date.now();
      // socket.emit('leave_room', { username, room, __createdtime__ });

      // socket.emit('join_room', { username, room });
      
      navigate('../chat', { replace: true });
    }

    // const roomJoined = JSON.parse(localStorage.getItem("roomJoined"));
    // const usernameJoined = JSON.parse(localStorage.getItem("usernameJoined"));

    // const roomJoined = localStorage.getItem("roomJoined");
    // const usernameJoined = localStorage.getItem("usernameJoined");

    // console.log("roomJoined-->>room", roomJoined);
    // console.log("usernameJoined-->>room", usernameJoined);

    // if ( ((typeof roomJoined !== undefined) && (roomJoined !== '')) && ((typeof usernameJoined !== undefined) && (usernameJoined !== '')) ) {
    //   socket.emit('join_room', { usernameJoined, roomJoined });
    //   navigate('../chat', { replace: true });
    // }

    getMentors()
    // getServants()

    setUserType(userData[0].userType)
    setUsername(userData[0].email)
  }, []);

  useEffect( () => {
    if(Object.keys(resData).length !== 0){
        console.log("yes res data.")

        if(resData.status===true){
          console.log("data-->>", resData.data)

          if(resData.data[0].userType==='0'){
            console.log("data-->>", resData.data[0].userType)
            setServants(resData.data)
          }
          
          if(resData.data[0].userType==='1'){
            getServants()
            console.log("data-->>", resData.data[0].userType)
            setMentors(resData.data)
          }

        }
    }
    else{
        console.log("no res data.")
    }
  }, [resData]);

  // useEffect( () => {
  //   if(Object.keys(resDataMentors).length !== 0){
  //       console.log("yes res data.")

  //       if(resDataMentors.status===true){
  //         console.log("res data is--", resDataMentors.data)
  //       }
  //   }
  //   else{
  //       console.log("no res data.")
  //   }
  // }, [resDataMentors]);

  // useEffect( () => {
  //   if(Object.keys(resDataServants).length !== 0){
  //       console.log("yes res data.")

  //       if(resDataServants.status===true){
  //         console.log("res data is--", resDataServants.data)
  //       }
  //   }
  //   else{
  //       console.log("no res data.")
  //   }
  // }, [resDataServants]);

  const getServants = () => {
    console.log("get servants...")
    let requestData = {
      'link' : 'admin/userList/0',
      'token' : 'required',
    };
    setreqData(requestData);
    // setreqDataServants(requestData);
  }

  const getMentors = () => {
    console.log("get mentors...")
    let requestData = {
      'link' : 'admin/userList/1',
      'token' : 'required',
    };
    // setreqDataMentors(requestData);
    setreqData(requestData);
  }

  const handleAdmin = (e) => {
    setAdmin(e.target.checked);

    if(userType==='0')// civil servant
      setRoom((e.target.checked?ADMIN+'_':'') + (mentor?mentor+'_':'') + userData[0].email);
    else if(userType==='1')// mentor
      setRoom((e.target.checked?ADMIN+'_':'') + userData[0].email + (servant?'_'+servant:''));
  };

  const handleMentor = (e) => {
    setMentor(e.target.value);

    if(userType==='0')// civil servant
      setRoom((admin?ADMIN+'_':'') + (e.target.value?e.target.value+'_':'') + userData[0].email);
    else if(userData[0].userType==='2')// admin
      setRoom(userData[0].email + (e.target.value?'_'+e.target.value:'') + (servant?'_'+servant:''));
  };

  const handleServant = (e) => {
    setServant(e.target.value);

    if(userType==='1')// mentor
      setRoom((admin?ADMIN+'_':'') + userData[0].email + (e.target.value?'_'+e.target.value:''));
    else if(userData[0].userType==='2')// admin
      setRoom(userData[0].email + (mentor?'_'+mentor:'') + (e.target.value?'_'+e.target.value:''));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (admin===false && mentor==='' && servant==='') {
      setError(true);
    } else {
      setError(false);
      joinRoom();
    }
  };

  const errorMessage = () => {
    return (
      <div
        className="error"
        style={{
          display: error ? '' : 'none',
        }}>
        <h1>Please select at least one optioin.</h1>
      </div>
    );
  };
 
  const joinRoom = () => {
    console.log("room->", room)
    console.log("username->", username)

    if (room !== '' && username !== '') {
      // localStorage.setItem("roomJoined", room)
      // localStorage.setItem("usernameJoined", username)

      socket.emit('join_room', { username, room });
      navigate('../chat', { replace: true });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <h1>{`Chat Rooms`}</h1>
        
        <span className="validation-error">
          {errorMessage()}
        </span>

        <form>
          {(userType!=='2') ? (
            <>
              <label htmlFor="admin">Admin</label>
              <input 
                className={styles.input} 
                onChange={handleAdmin}
                type="checkbox" 
                name="admin" 
              />
            </>
          ) : (
            null
          )}

          {(userType!=='1') ? (
            <select
              className={styles.input}
              onChange={handleMentor}
            >
              <option value="">-- Select Mentor --</option>
              {
                mentors && mentors.map((mentor, index) =>{
                  return (
                    <option key={mentor.id} value={mentor.email}>{mentor.email}</option>
                  );
                })
              }
            </select>
          ) : (
            null
          )}

          {(userType!=='0') ? (
            <select
              className={styles.input}
              onChange={handleServant}
            >
              <option value="">-- Select Servant --</option>
              {
                servants && servants.map((servant, index) =>{
                  return (
                    <option key={servant.id} value={servant.email}>{servant.email}</option>
                  );
                })
              }
            </select>
          ) : (
            null
          )}

          <button
            className='btn btn-secondary'
            style={{ width: '100%' }}
            onClick={handleSubmit}
            type="submit"
          >
            Join Room
          </button>
        </form>

      </div>
    </div>
  );
};

export default ChatHome;